const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#F6F8FA",
    minHeight: "100vh",
  },
  appBar: {
    backgroundColor: theme.palette.darkGrey.main,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  loadingView: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    flexGrow: 1,
    marginTop: 18,
    marginBottom: 18,
    fontWeight: 900,
    color: "#1F2937",
  },
  formContainer: {
    paddingTop: "30px",
    paddingBottom: "30px",
    width: "100%",
    margin: "0 auto",
  },
  form: {
    width: "100%",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#FFFFFF",
      "& fieldset": {
        borderColor: "#E0E0E0",
      },
      "&:hover fieldset": {
        borderColor: "#BDBDBD",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  select: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#FFFFFF",
      "& fieldset": {
        borderColor: "#E0E0E0",
      },
      "&:hover fieldset": {
        borderColor: "#BDBDBD",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  checkbox: {
    color: "#757575",
    "&.Mui-checked": {
      color: theme.palette.primary.main,
    },
  },
  stripeConnectBox: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    border: "1px solid #E5E7EB",
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  },
  iconUploadButton: {
    transition: "filter 0.15s ease, transform 0.15s ease",
    "&:hover": {
      filter: "brightness(0.9)",
      transform: "translateY(-1px)",
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  deleteIconButton: {
    transition: "filter 0.15s ease",
    "&:hover": {
      filter: "brightness(0.95)",
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  softButton: {
    transition: "filter 0.15s ease",
    "&:hover": {
      filter: "brightness(0.97)",
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  coordsRow: {
    flexWrap: "wrap",
    "& > *": {
      flex: "1 1 140px",
    },
  },
  actionBar: {
    [theme.breakpoints.up("sm")]: {
      left: "280px !important",
    },
  },
  imageCardInGameBackground: {
    marginLeft: 10,
    width: 411 / 6,
    height: 794 / 6,
    [theme.breakpoints.up("md")]: {
      marginLeft: 10,
      width: 411 / 3,
      height: 794 / 3,
    },
    marginTop: 20,
  },
  imageCardBackground: {
    marginLeft: 10,
    width: 411 / 4,
    height: 794 / 4,
    [theme.breakpoints.up("md")]: {
      width: 411 / 3,
      height: 794 / 3,
    },
  },
  hrVertical: {
    borderLeft: "1px solid #E5E7EB",
    height: "700px",
    flexShrink: 0,
    marginRight: -10,
    width: 1,
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "inline",
    },
  },
  gridBorder: {
    borderRight: null,
    [theme.breakpoints.up("lg")]: {
      borderRight: "1px solid #E5E7EB",
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: "white",
    borderRadius: "12px",
    padding: theme.spacing(3),
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    marginBottom: theme.spacing(3),
  },
  imageCardBackgroundTab: {
    marginLeft: 10,
    width: 1024 / 8,
    height: 1310 / 8,
    [theme.breakpoints.up("md")]: {
      width: 1024 / 4,
      height: 1310 / 4,
    },
  },
  imageCardBackgroundInList: {
    marginLeft: 10,
    width: 50,
    height: 50,
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: 100,
      height: 100,
    },
  },
  imageCardBackgroundInListTab: {
    marginLeft: 10,
    width: 50,
    height: 50,
    marginTop: 0,
    [theme.breakpoints.up("md")]: {
      width: 100,
      height: 100,
    },
  },
  alignCenterXs: {
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.up("lg")]: {
      justifyContent: "start",
      alignItems: "start",
    },
  },
  mapButton: {
    backgroundColor: theme.palette.orange.main,
    color: "#ffffff",
    fontSize: "0.875rem",
    fontWeight: 600,
    borderRadius: "50px",
    height: 40,
    marginTop: 9,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
      transform: "translateY(-2px)",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
  },
  imageCardAnnotation: {
    marginLeft: 10,
    width: 75,
    height: 75,
    marginTop: 20,
  },
  imageCardMedia: {
    width: "100%",
    height: "100%",
    backgroundColor: "#E5E8EB",
    borderRadius: 8,
  },
  uploadFile: {
    color: "white",
    width: "50%",
    marginTop: 10,
    marginLeft: 10,
    marginBottom: 6,
    backgroundColor: "#F48A21",
    borderRadius: "50px",
    fontWeight: 600,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
      transform: "translateY(-2px)",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
  },
  link: {
    textDecoration: "none",
  },
  listContainer: {
    display: "flex",
    justifyContent: "center",
  },
  list: {
    backgroundColor: "white",
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    borderRadius: 12,
    border: "1px solid #E5E7EB",
    listStyle: "none",
    width: "60%",
    padding: theme.spacing(3),
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  },
  buttonListPlus: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "50px",
    color: "white",
    fontWeight: 600,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      transform: "translateY(-2px)",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
  },
  imageDimensionsText: {
    paddingLeft: 8,
    color: "#6B7280",
    fontSize: "0.875rem",
  },
  imageInfos: {
    paddingTop: 18,
    paddingLeft: 8,
    color: "#4B5563",
    fontSize: "0.875rem",
    fontWeight: 600,
  },
  textFieldContainer: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: 24,
    width: "80%",
    border: "1px solid #E5E7EB",
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  },
  textFieldLight: {
    backgroundColor: "white",
    borderRadius: 8,
    marginBottom: 32,
    width: "90%",
  },
  helperText: {
    marginTop: 8,
    fontSize: "0.75rem",
    color: "#6B7280",
  },
  markdownEditorContainer: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    border: "1px solid #E0E0E0",
    overflow: "hidden",
    boxShadow: "0 1px 2px rgba(17, 24, 39, 0.04)",
    "& .w-md-editor": {
      boxShadow: "none",
      backgroundColor: "transparent",
      "--md-editor-font-family":
        'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    },
    "& .w-md-editor-area, & .w-md-editor-input, & .w-md-editor-text": {
      height: "100%",
    },
    "& .w-md-editor-text": {
      minHeight: "100%",
      boxSizing: "border-box",
    },
    "& .w-md-editor-toolbar": {
      borderBottom: "1px solid #E0E0E0",
      backgroundColor: "#F9FAFB",
    },
    "& .w-md-editor-toolbar ul > li > button": {
      color: "#374151",
    },
    "& .w-md-editor-toolbar svg": {
      color: "#111827",
    },
    "& .w-md-editor-content": {
      position: "relative",
      backgroundColor: "#FFFFFF",
      display: "flex !important",
      flexDirection: "row",
      alignItems: "stretch",
      height: "100%",
    },
    "& .w-md-editor-input": {
      backgroundColor: "#F9FAFB",
      borderRight: "1px solid #E5E7EB",
      position: "relative",
      flex: "1 1 50%",
      width: "50% !important",
      minWidth: 0,
      paddingTop: 32,
      boxSizing: "border-box",
      "&::before": {
        content: "var(--md-edit-label, '\"Édition\"')",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 28,
        display: "flex",
        alignItems: "center",
        paddingLeft: 12,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "#2563EB",
        backgroundColor: "#EFF6FF",
        borderBottom: "1px solid #DBEAFE",
        zIndex: 2,
        pointerEvents: "none",
      },
    },
    "& .w-md-editor-preview": {
      backgroundColor: "#FFFFFF",
      position: "relative !important",
      flex: "1 1 50%",
      width: "50% !important",
      minWidth: 0,
      top: "unset !important",
      right: "unset !important",
      bottom: "unset !important",
      left: "unset !important",
      paddingTop: "32px !important",
      boxSizing: "border-box",
      overflow: "auto",
      "&::before": {
        content: "var(--md-preview-label, '\"Aperçu\"')",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 28,
        display: "flex",
        alignItems: "center",
        paddingLeft: 12,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "#047857",
        backgroundColor: "#ECFDF5",
        borderBottom: "1px solid #D1FAE5",
        zIndex: 2,
        pointerEvents: "none",
      },
      "& .wmde-markdown": {
        backgroundColor: "transparent",
        padding: "8px 12px",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: 14,
        lineHeight: "22px",
        color: "#111827",
      },
    },
    "& .w-md-editor-bar": {
      display: "none",
    },
    "& .w-md-editor-text-input, & .w-md-editor-text-pre, & .w-md-editor-text-pre > code":
    {
      fontFamily:
        'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important',
      fontWeight: "400 !important",
      fontStyle: "normal !important",
      fontVariantLigatures: "none !important",
      fontFeatureSettings: '"liga" 0, "calt" 0 !important',
      fontKerning: "none !important",
      letterSpacing: "normal !important",
      tabSize: "2 !important",
      boxSizing: "border-box",
      fontSize: "14px",
      lineHeight: "22px",
      color: "#111827",
    },
    [theme.breakpoints.down("sm")]: {
      "& .w-md-editor-content": {
        flexDirection: "column",
      },
      "& .w-md-editor-input, & .w-md-editor-preview": {
        width: "100% !important",
        flex: "1 1 auto",
      },
      "& .w-md-editor-input": {
        borderRight: "none",
        borderBottom: "1px solid #E5E7EB",
      },
    },
  },
  markdownEditorHint: {
    fontSize: 12,
    color: "#6B7280",
    marginTop: 6,
    marginLeft: 2,
    fontStyle: "italic",
  },
  headerLocations: {
    fontSize: "0.875rem",
    fontWeight: 800,
    marginLeft: 12,
    color: "#1F2937",
  },
  valueSliderLabel: {
    left: "auto !important",
    top: "-2em",
    "& *": {
      background: "transparent",
      color: "#1F2937",
    },
  },
  pannel: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: theme.spacing(3),
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    border: "1px solid #E5E7EB",
  },
  returnButtonLink: {
    textDecoration: "none",
  },
  saveButton: {
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.darkGrey.main,
    fontSize: 15,
    fontWeight: 700,
    borderWidth: "0px",
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  textfieldWhite: {
    backgroundColor: "white",
  },
  banner: {
    backgroundColor: "#B85A00",
    textAlign: "center",
    fontSize: 16,
    fontWeight: 900,
    padding: "15px",
    color: "white",
    borderRadius: "8px",
    margin: "16px",
    // marginBottom: "10px",
  },
  buttonDisabled: {
    backgroundColor: "#CBD5E1",
    color: "#475569",
    cursor: "not-allowed",
    "&:hover": {
      backgroundColor: "#CBD5E1",
    },
  },
  mainContent: {
    marginLeft: 280,
    paddingBottom: 100,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 0,
    },
  },

  // thumb: {
  //   height: 15,
  //   width: 15,
  //   backgroundColor: "#fff",
  //   border: "2px solid currentColor",
  //   marginTop: -6,
  //   marginLeft: -11,
  //   "&:focus, &:hover, &$active": {
  //     boxShadow: "inherit",
  //   },
  // },
  // track: {
  //   height: 8,
  //   borderRadius: 4,
  //   backgroundColor: "#fff",
  // },
  // rail: {
  //   height: 8,
  //   borderRadius: 4,
  //   backgroundColor: "#fff",
  // },
  // mark: {
  //   backgroundColor: "#bfbfbf",
  //   height: 10,
  //   width: 10,
  //   borderRadius: "50%",
  //   marginTop: -3,
  // },
  // markActive: {
  //   backgroundColor: "currentColor",
  // },
});

export default styles;
